module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    ref: "dropzone",
    staticClass: "dropzone",
    class: {
      'dropzone--single': _vm.maxNumberOfFiles === 1
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89afa0dc","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Dropzone.vue
// module id = 1Dk2
// module chunks = 0 1